import {LoginType} from '../../utils/services/types';

export const wexRedirects: Record<LoginType, string> = {
    AAD: '/services/oauth_handler/hpbp/sign_in?acr_values=urn:hpbp:azure_ad',
    HPID: '/services/oauth_handler/hpbp/sign_in',
    default: '/',
};
